<template>
  <v-dialog
    v-model="show"
    :max-width="language == 'mk' ? 480 : 440"
    overlay-color="darktext"
    overlay-opacity="0.6"
    @click:outside="persistent ? '' : closeDialog()"
    :persistent="persistent"
  >
    <v-card>
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <!-- eslint-disable vue/no-v-html -->
      
      <v-card-text v-if="cdAdditonalText != ''" v-html="cdAdditonalText"/>
      <v-card-text v-html="cdText"/>
      <v-card-actions class="flex-column  flex-sm-column flex-md-row align-end pa-6">
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          :color="cdCancelBtnColor"
          min-width="100"
          elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0 white--text"
          :class="{'disable-events': loading || loadingCancel}"
          @click="show=false"
        >
          {{ cdCancelBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    id: {
      type: Number,
      default: 0
    },
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('ok')
    },
    cdSubmitBtnColor: {
        type: String,
        default: 'error'
    },
    cdCancelBtnColor: {
        type: String,
        default: 'darktext'
    },
    persistent: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cdAdditonalText: {
      type: String,
      default: ''
    },
  },
  data(){
    return{
      language: window.$cookies.get('language') ? window.$cookies.get('language') : 'en',
      loading: false,
      loadingCancel: false
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.loadingCancel = true
          this.$emit('close')
        }
         
      }
    }
  },
  methods: {
    closeDialog() {
      this.loading = true
      this.$emit('input', false);
    }
  },
}
</script>